// extracted by mini-css-extract-plugin
export default {"vehicleCategory":"xVdgN2kn_U","title":"W3XZLY7qIW","description":"GoqaPvZQX9","ctaGroup":"vYbof21dIE","ctaBtn":"zE1wAFsLkF","grid":"xJFw7J9vUq"};